import React, { useEffect } from 'react';

import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { useQuery } from 'react-query';

import NavBar from '../NavBar';
import TrainingPathPlaylistSidebar from '../../../components/TrainingPathPlaylistSidebar';

import classes from './styles.module.scss';

import logo from '../../../assets/images/snapsop3.jpg';
import collapse from '../../../assets/images/nav/collapse.svg';
import { useUiStore } from '../../../store';
import UserService from '../../../services/UserService';

let wasToggledAutomatically = false;

export default function Sidebar({ trainingPathPlaylist }) {
  const isSidebarCollapsed = useUiStore((state) => state.isSidebarCollapsed);
  const toggleSidebar = useUiStore((state) => state.toggleSidebar);

  const isNarrowDesktop = useMediaQuery({ maxWidth: 1600 });

  const { data: currentUser } = useQuery('me', UserService.getMe);
  const isImpersonating = currentUser?.impersonation?.isImpersonating;

  useEffect(() => {
    // Don't auto-collapse sidebar for training path pages
    if (isNarrowDesktop && !isSidebarCollapsed && !wasToggledAutomatically && !trainingPathPlaylist) {
      toggleSidebar();
      wasToggledAutomatically = true;
    }
  }, [isNarrowDesktop, isSidebarCollapsed, toggleSidebar, trainingPathPlaylist]);

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <nav
      className={classNames(classes.Sidebar, {
        [classes.collapsed]: isSidebarCollapsed,
        [classes.impersonating]: isImpersonating,
      })}
      onClick={toggleSidebar}
    >
      <div
        className={classes.logoContainer}
      >
        <Link
          onClick={(event) => event.stopPropagation()}
          to="/"
        >
          <img src={logo} alt="Logo" className={classes.logo} />
        </Link>
      </div>
      {trainingPathPlaylist ? (
        <TrainingPathPlaylistSidebar
          trainingPathName={trainingPathPlaylist.trainingPathName}
          content={trainingPathPlaylist.content}
          currentMeetingId={trainingPathPlaylist.currentMeetingId}
          trainingPathAssignmentId={trainingPathPlaylist.trainingPathAssignmentId}
          isLoading={trainingPathPlaylist.isLoading}
          isCollapsed={isSidebarCollapsed}
        />
      ) : (
        <>
          <NavBar />
        </>
      )}
      <div className={classes.collapseButtonContainer}>
        <button
          className={classes.collapseButton}
          // onClick={toggleSidebar}
          type="button"
        >
          <img src={collapse} alt="Collapse" />
        </button>
      </div>
    </nav>
  );
}
